import globals from './_globals'
import breadcrumb from './_breadcrumb'
import menu from './_menu'
import dashboard from './_dashboard'
import auth from './_auth'
import admin from './_admin'

const en = {
    globals,
    breadcrumb,
    menu,
    dashboard,
    auth,
    admin,
}

export default en
